@if (isLoading) {
  <span style="margin-left:8px; text-align: center;">
    <i class="pi pi-spin pi-spinner" style="font-size: 3em"></i>
  </span>
}